<template>
    <div class="max-w-screen flex h-screen w-full">
        <!-- Sidebar: hidden on mobile for field staff (CSS handles responsiveness) -->
        <aside
            v-if="showLayout"
            class="relative border-r"
            :class="[appStore.sideMini ? 'lg:w-16' : 'lg:w-64', isRestrictedFieldStaff ? 'hidden lg:block' : '']"
        >
            <button
                type="button"
                class="absolute -right-4 top-7 z-50 hidden h-7 lg:block"
                @click="appStore.sideMini = !appStore.sideMini"
            >
                <div class="w-fit rounded-full border bg-white p-0.5 shadow">
                    <SvgIcon
                        name="system-chevron-left"
                        class="size-5 text-muval-gray-2 transition"
                        :class="appStore.sideMini && 'rotate-180'"
                    />
                </div>
            </button>
            <NavigationController />
        </aside>
        <div class="relative flex w-0 flex-1 flex-col">
            <NewTopHeader
                v-if="showLayout && !isRestrictedFieldStaff"
                class="z-40 -mb-1 bg-white px-4 pb-4 transition-shadow lg:px-8"
                :class="[
                    fullWidthView ? 'max-w-full' : 'max-w-[1920px]',
                    !arrivedState.top ? 'shadow-sm' : 'shadow-none',
                ]"
            />
            <main
                id="layout-main-scroll-container"
                ref="mainSection"
                class="flex-1 overflow-auto pt-2"
                :class="isRestrictedFieldStaff ? 'field-staff-main' : 'h-[calc(100vh-60px)]'"
            >
                <div
                    class="h-full lg:px-8"
                    :class="fullWidthView ? 'max-w-full' : 'max-w-[1920px]'"
                >
                    <div
                        :class="{
                            'h-full': fullHeightView,
                            'pb-4 lg:pb-8': !fullHeightView,
                        }"
                    >
                        <slot />
                    </div>
                </div>
            </main>
        </div>
        <NotificationSlideOver
            v-if="userStore.isAuthenticated"
            class="z-40"
        />
        <ThemeManager />
        <!-- Mobile bottom bar for field staff -->
        <MobileBottomBar
            v-if="showLayout && isRestrictedFieldStaff"
            class="lg:hidden"
        />
    </div>
</template>
<script setup>
const userStore = useUserStore();
const route = useRoute();
const appStore = useAppStore();

const showLayout = computed(() => {
    return (
        userStore.isAuthenticated &&
        route.name !== 'Login' &&
        route.name !== 'Register' &&
        route.name !== 'Update your preferences'
    );
});

const fullWidthView = computed(() => {
    return route.meta?.fullWidth;
});

const fullHeightView = computed(() => {
    return route.meta?.fullHeight;
});

// Field staff get bottom bar on mobile (CSS handles the breakpoint)
const isRestrictedFieldStaff = computed(() => userStore.isRestrictedFieldStaff?.());

const mainSection = useTemplateRef('mainSection');
const { arrivedState } = useScroll(mainSection);
</script>

<style scoped>
.field-staff-main {
    max-height: calc(100dvh - 3.5rem - env(safe-area-inset-bottom, 0px));
}

@media (min-width: 1024px) {
    .field-staff-main {
        max-height: none;
    }
}
</style>
